import * as PIXI from 'pixi.js'

type BitmapTextStyle = Record<string, unknown>
type TextStyle = Record<string, unknown> & { maxWidth?: number }

//## Golden Coin Symbol
export const COIN_VALUE_STYLE: BitmapTextStyle = {
    align: 'center',
    fontFamily: 'GoldNumberFont',
    fontSize: 125,
    // Glyph cells include transparent padding; tighten tracking on coin labels.
    letterSpacing: -14,
    maxWidth: 190,
}

export const FREE_SPINS_COUNTER_STYLE: BitmapTextStyle = {
    align: 'center',
    fontFamily: 'counter_bitmap_font',
    fontSize: 85,
    letterSpacing: 0,
}

export const JACKPOT_LADDER_NUMBER_STYLE: BitmapTextStyle = {
    align: 'center',
    fontFamily: 'jackpot_numbers_bitmap_font',
    fontSize: 38,
    letterSpacing: 0,
}

export const JACKPOT_LADDER_STEP_PRIZE_STYLE: BitmapTextStyle = {
    align: 'center',
    fontFamily: 'commendationBitmapfonts',
    fontSize: 10,
    letterSpacing: 0,
}

export const JACKPOT_POPUP_PRIZE_STYLE: BitmapTextStyle = {
    align: 'center',
    fontFamily: 'commendationBitmapfonts',
    fontSize: 10,
    letterSpacing: 0,
}

export const BUY_BONUS_VALUE_STYLE: BitmapTextStyle = {
    align: 'center',
    fontFamily: 'commendationBitmapfonts',
    fontSize: 10.88,
    letterSpacing: 0,
}

//## Buy Bonus insufficient-balance warning.
export const BUY_BONUS_INSUFFICIENT_STYLE: TextStyle = {
    fontFamily: 'Montserrat_Bold',
    align: 'center',
    fontSize: 40,
    fill: '#ff5a5a',
    stroke: {
        color: '#2a0000',
        width: 6,
        join: 'round',
    },
    lineJoin: 'round',
}

export const TOP_PANEL_VALUE_STYLE: TextStyle = {
    dropShadow: true,
    dropShadowAngle: 1,
    dropShadowBlur: 3,
    dropShadowColor: '#0f0000',
    dropShadowDistance: 5,
    fill: '#ffffff',
    fontFamily: 'Roboto-Black',
    fontSize: 38,
}

export const TOP_PANEL_TITLE_STYLE: TextStyle = {
    fontFamily: 'Agbalumo',
    align: 'center',
    fill: '#ce0285',
    fontSize: 28,
    lineJoin: 'round',
    stroke: '#fff5ab',
    strokeThickness: 10,
    fontWeight: 'bold',
}

export const WIN_LABEL_GRADIENT_FILL = new PIXI.FillGradient({
    type: 'linear',
    start: { x: 0, y: 0 },
    end: { x: 0, y: 1 },
    textureSpace: 'local',
    colorStops: [
        { offset: 0, color: 0xf9f2a3 },
        { offset: 0.23, color: 0xfaee8c },
        { offset: 0.31, color: 0xfdec62 },
        { offset: 0.38, color: 0xfbde48 },
        { offset: 0.51, color: 0xe4b652 },
        { offset: 0.63, color: 0xdb9a34 },
        { offset: 0.78, color: 0xfbd739 },
        { offset: 1, color: 0xfbd739 },
    ],
})

export const TICKER_MESSAGE_GRADIENT_FILL = new PIXI.FillGradient({
    type: 'linear',
    start: { x: 0, y: 0 },
    end: { x: 0, y: 1 },
    textureSpace: 'local',
    colorStops: [
        { offset: 0, color: 0xf9f2a3 },
        { offset: 0.23, color: 0xfaee8c },
        { offset: 0.31, color: 0xfdec62 },
        { offset: 0.38, color: 0xfbde48 },
        { offset: 0.51, color: 0xe4b652 },
        { offset: 0.63, color: 0xdb9a34 },
        { offset: 0.78, color: 0xfbd739 },
        { offset: 1, color: 0xfbd739 },
    ],
})

export const WIN_LABEL_STYLE: TextStyle = {
    fontFamily: 'Roboto-Black',
    fontSize: 50,
    fill: WIN_LABEL_GRADIENT_FILL,
    dropShadow: {
        angle: Math.PI / 2,
        blur: 4,
        color: '#000d1a',
        distance: 4,
        alpha: 0.45,
    },
    lineJoin: 'round',
}

export const TICKER_MESSAGE_STYLE: TextStyle = {
    fontFamily: 'Montserrat_Bold',
    fontSize: 37,
    fontWeight: '700',
    fill: TICKER_MESSAGE_GRADIENT_FILL,
    stroke: {
        color: '#000d1a',
        width: 8,
        join: 'round',
    },
    dropShadow: {
        angle: Math.PI / 2,
        blur: 2,
        color: '#000d1a',
        distance: 2,
        alpha: 0.45,
    },
    lineJoin: 'round',
    letterSpacing: -1,
    align: 'center',
    padding: 12,
    maxWidth: 550,
}

export const POPUP_TITLE_STYLE: TextStyle = {
    fontFamily: 'Agbalumo',
    align: 'center',
    fill: '#fbc848',
    fontSize: 100,
    lineJoin: 'round',
    stroke: '#a52325',
    strokeThickness: 10,
    dropShadow: true,
    dropShadowAngle: 0,
    dropShadowBlur: 14,
    dropShadowColor: '#a52325',
    dropShadowDistance: 1,
}

export const POPUP_STYLE: TextStyle = {
    fontFamily: 'Agbalumo',
    align: 'center',
    fill: '#fbc848',
    fontSize: 60,
    lineJoin: 'round',
    stroke: '#a52325',
    strokeThickness: 10,
    dropShadow: true,
    dropShadowAngle: 0,
    dropShadowBlur: 8,
    dropShadowColor: '#a52325',
    dropShadowDistance: 1,
}

export const POPUP_SMALL_STYLE: TextStyle = {
    fontFamily: 'Roboto-Black',
    align: 'center',
    fontSize: 34,
    fill: '#b7185e',
    fontWeight: 'bold',
}

export const BUY_BONUS_LABEL_GRADIENT_FILL = new PIXI.FillGradient({
    type: 'linear',
    start: { x: 0, y: 0 },
    end: { x: 0, y: 1 },
    textureSpace: 'local',
    colorStops: [
        { offset: 0, color: 0xf9f2a3 },
        { offset: 0.23, color: 0xfaee8c },
        { offset: 0.31, color: 0xfdec62 },
        { offset: 0.38, color: 0xfbde48 },
        { offset: 0.51, color: 0xe4b652 },
        { offset: 0.63, color: 0xdb9a34 },
        { offset: 0.78, color: 0xfbd739 },
        { offset: 1, color: 0xfbd739 },
    ],
})

export const BUY_BONUS_LABEL_STYLE: TextStyle = {
    fontFamily: 'Roboto-Black',
    fontSize: 65,
    fill: BUY_BONUS_LABEL_GRADIENT_FILL,
    dropShadow: {
        angle: Math.PI / 2,
        blur: 4,
        color: '#000d1a',
        distance: 4,
        alpha: 0.45,
    },
    lineJoin: 'round',
    letterSpacing: -1,
}

//## --------------------------- Word art typed as text -------------------------------------------
//## Redraws of words baked into atlases and spine skins, which only ever exist in English and in the
//## social-casino rewording. Every colour and measurement below is sampled off the 1x source art.
//##
//## They are used with OutlinedTextLabel, which stacks the styles as separate copies of the word.

/** Both labels sit on the same navy the artwork outlines everything in. */
const WORD_ART_OUTLINE_NAVY = '#002650'
const WORD_ART_SHADOW_COLOR = '#040c26'

/** Exported because the layer that casts the shadow has to be nudged by half of it. */
export const WORD_ART_SHADOW_DISTANCE = 10

//## A `textureSpace: 'local'` gradient is stretched over the text's whole line box — from the top of
//## PixiJS' metrics string down to its descender — but the art ramps over the capitals alone. Roboto
//## Black measures a line box 1.145x its font size, holding a cap of 0.710x seated on a baseline
//## 0.945x down, which puts the capitals between these two fractions of the box. Squeeze the sampled
//## stops into that band: spread over the whole box, the highlights would miss the glyphs entirely.
const WORD_ART_CAP_BAND_TOP = 0.205
const WORD_ART_CAP_BAND_BOTTOM = 0.825

type ColorStop = { offset: number; color: number }

/** Sampled stops are given as fractions of the cap height; this maps them onto the line box. */
const overCapBand = (stops: ColorStop[]): PIXI.FillGradient =>
    new PIXI.FillGradient({
        type: 'linear',
        start: { x: 0, y: 0 },
        end: { x: 0, y: 1 },
        textureSpace: 'local',
        colorStops: [
            { offset: 0, color: stops[0].color },
            ...stops.map(({ offset, color }) => ({
                offset: WORD_ART_CAP_BAND_TOP + offset * (WORD_ART_CAP_BAND_BOTTOM - WORD_ART_CAP_BAND_TOP),
                color,
            })),
            { offset: 1, color: stops[stops.length - 1].color },
        ],
    })

const wordArtFillStyle = (fontSize: number, letterSpacing: number, fill: PIXI.FillGradient): TextStyle => ({
    fontFamily: 'Roboto-Black',
    fontSize,
    align: 'center',
    letterSpacing,
    fill,
    lineJoin: 'round',
})

/** Flat copy drawn behind the fill; `width` is twice the outline the art shows, half of it hidden. */
const wordArtOutlineStyle = (fontSize: number, letterSpacing: number, color: string, width: number): TextStyle => ({
    fontFamily: 'Roboto-Black',
    fontSize,
    align: 'center',
    letterSpacing,
    fill: color,
    stroke: {
        color,
        width,
        join: 'round',
    },
    dropShadow: {
        angle: Math.PI / 2,
        blur: 12,
        color: WORD_ART_SHADOW_COLOR,
        distance: WORD_ART_SHADOW_DISTANCE,
        alpha: 0.5,
    },
    lineJoin: 'round',
    //## Room for the blur, which PixiJS does not measure (it only budgets for the shadow's distance).
    padding: width,
})

//## `buytext*.png`: "BUY" in a heavy grotesque, 103px cap inside a 356x164 frame, 12px navy outline.
//## Roboto Black sets it 6% narrower than the art, which the tracking makes up.
const BUY_BONUS_CONFIRM_LABEL_FONT_SIZE = 145
const BUY_BONUS_CONFIRM_LABEL_LETTER_SPACING = 4
const BUY_BONUS_CONFIRM_LABEL_OUTLINE_WIDTH = 24

const buyBonusConfirmPalette = (fill: PIXI.FillGradient, outline: string) => ({
    fill: wordArtFillStyle(BUY_BONUS_CONFIRM_LABEL_FONT_SIZE, BUY_BONUS_CONFIRM_LABEL_LETTER_SPACING, fill),
    outline: wordArtOutlineStyle(
        BUY_BONUS_CONFIRM_LABEL_FONT_SIZE,
        BUY_BONUS_CONFIRM_LABEL_LETTER_SPACING,
        outline,
        BUY_BONUS_CONFIRM_LABEL_OUTLINE_WIDTH
    ),
})

export const BUY_BONUS_CONFIRM_LABEL_STYLES = {
    enabled: buyBonusConfirmPalette(
        overCapBand([
            { offset: 0, color: 0xfffaa1 },
            { offset: 0.08, color: 0xf2da8d },
            { offset: 0.2, color: 0xfdfbdc },
            { offset: 0.31, color: 0xffffff },
            { offset: 0.39, color: 0xfffd77 },
            { offset: 0.47, color: 0xf7e144 },
            { offset: 0.59, color: 0xe3ab37 },
            { offset: 0.67, color: 0xe5ad35 },
            { offset: 0.82, color: 0xffe33c },
            { offset: 0.9, color: 0xf3ca34 },
            { offset: 1, color: 0xe2a628 },
        ]),
        WORD_ART_OUTLINE_NAVY
    ),
    disabled: buyBonusConfirmPalette(
        overCapBand([
            { offset: 0, color: 0xbdbdbd },
            { offset: 0.08, color: 0xa7a7a7 },
            { offset: 0.16, color: 0xbcbcbc },
            { offset: 0.27, color: 0xd6d6d6 },
            { offset: 0.35, color: 0xd7d7d7 },
            { offset: 0.43, color: 0x9d9d9d },
            { offset: 0.51, color: 0x929292 },
            { offset: 0.63, color: 0x7b7b7b },
            { offset: 0.75, color: 0x8a8a8a },
            { offset: 0.86, color: 0x909090 },
            { offset: 1, color: 0x777777 },
        ]),
        '#1a1a1a'
    ),
} as const

//## The "BET PER SPIN" / "TOTAL BET" captions on the Buy Bonus message box, drawn into the spine's BUY
//## and PLAY skins. Chrome-blue lettering with a 63px cap over a 12px navy outline and a 7px extruded
//## bottom face, in a condensed face that Roboto Black matches once squeezed (see the label below).
const BUY_BONUS_CAPTION_FONT_SIZE = 89
const BUY_BONUS_CAPTION_LETTER_SPACING = 0
const BUY_BONUS_CAPTION_OUTLINE_WIDTH = 24

export const BUY_BONUS_CAPTION_STYLES = {
    fill: wordArtFillStyle(
        BUY_BONUS_CAPTION_FONT_SIZE,
        BUY_BONUS_CAPTION_LETTER_SPACING,
        overCapBand([
            { offset: 0, color: 0xffffff },
            { offset: 0.06, color: 0xdafeff },
            { offset: 0.09, color: 0xb3c9e5 },
            { offset: 0.15, color: 0xbccfe8 },
            { offset: 0.21, color: 0xd5e0f1 },
            { offset: 0.27, color: 0xeef2f9 },
            { offset: 0.32, color: 0xffffff },
            { offset: 0.4, color: 0xe7eef9 },
            { offset: 0.47, color: 0xd3def0 },
            { offset: 0.55, color: 0xc7d2e4 },
            { offset: 0.63, color: 0xbec6d9 },
            { offset: 0.71, color: 0xbac2d4 },
            { offset: 0.79, color: 0xb9cae3 },
            { offset: 0.87, color: 0xaec3e1 },
            { offset: 0.95, color: 0x9cb6da },
            { offset: 1, color: 0x84a3ce },
        ])
    ),
    outline: wordArtOutlineStyle(
        BUY_BONUS_CAPTION_FONT_SIZE,
        BUY_BONUS_CAPTION_LETTER_SPACING,
        WORD_ART_OUTLINE_NAVY,
        BUY_BONUS_CAPTION_OUTLINE_WIDTH
    ),
    //## Only its lowest few pixels show, past the fill: the darker blue face under the lettering.
    bevel: {
        fontFamily: 'Roboto-Black',
        fontSize: BUY_BONUS_CAPTION_FONT_SIZE,
        align: 'center',
        letterSpacing: BUY_BONUS_CAPTION_LETTER_SPACING,
        fill: '#375280',
        lineJoin: 'round',
    } as TextStyle,
} as const

//## Max exposure popup gradient.
export const MAX_EXPOSURE_TITLE_GRADIENT_FILL = new PIXI.FillGradient({
    type: 'linear',
    start: { x: 0, y: 0 },
    end: { x: 0, y: 1 },
    textureSpace: 'local',
    colorStops: [
        { offset: 0, color: 0xf9f2a3 },
        { offset: 0.23, color: 0xfaee8c },
        { offset: 0.31, color: 0xfdec62 },
        { offset: 0.38, color: 0xfbde48 },
        { offset: 0.51, color: 0xe4b652 },
        { offset: 0.63, color: 0xdb9a34 },
        { offset: 0.78, color: 0xfbd739 },
        { offset: 1, color: 0xfbd739 },
    ],
})

//## Max exposure popup title.
export const MAX_EXPOSURE_TITLE_STYLE: TextStyle = {
    fontFamily: 'Roboto-Black',
    fontSize: 80,
    fill: MAX_EXPOSURE_TITLE_GRADIENT_FILL,
    dropShadow: {
        angle: Math.PI / 2,
        blur: 4,
        color: '#000d1a',
        distance: 4,
        alpha: 0.45,
    },
    lineJoin: 'round',
    letterSpacing: -1,
    align: 'center',
}

//## Unfinished Case
export const UNFINISHED_ROUND_TITLE_GRADIENT_FILL = new PIXI.FillGradient({
    type: 'linear',
    start: { x: 0, y: 0 },
    end: { x: 0, y: 1 },
    textureSpace: 'local',
    colorStops: [
        { offset: 0, color: 0xf9f2a3 },
        { offset: 0.23, color: 0xfaee8c },
        { offset: 0.31, color: 0xfdec62 },
        { offset: 0.38, color: 0xfbde48 },
        { offset: 0.51, color: 0xe4b652 },
        { offset: 0.63, color: 0xdb9a34 },
        { offset: 0.78, color: 0xfbd739 },
        { offset: 1, color: 0xfbd739 },
    ],
})

//## Unfinished round popup title.
export const UNFINISHED_ROUND_TITLE_STYLE: TextStyle = {
    fontFamily: 'Roboto-Black',
    fontSize: 60,
    fill: UNFINISHED_ROUND_TITLE_GRADIENT_FILL,
    dropShadow: {
        angle: Math.PI / 2,
        blur: 4,
        color: '#000d1a',
        distance: 4,
        alpha: 0.45,
    },
    lineJoin: 'round',
    letterSpacing: -1,
    align: 'center',
    maxWidth: 680,
}